// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerMode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, computed, action } from 'mobx';
import AlertDetails from 'logic/models/Izenda.AlertDetails';

export default class DashboardDesignerMode {
  @observable isPresentation: boolean = false;
  @observable isAccess: boolean = false;
  @observable isSubscribe: boolean = false;
  @observable isEdit: boolean = false;
  @observable isFullscreen: boolean = false;
  @observable isSchedule: boolean = false;
  @observable alertDetails: AlertDetails = new AlertDetails();

  @computed
  get isDesigner() {
    return !this.isPresentation && !this.isAccess && !this.isSubscribe && !this.isFullscreen && !this.isSchedule;
  }

  @computed
  get isDisabledCloseButton() {
    return this.isAccess || this.isSubscribe || this.isSchedule;
  }
  @computed
  get isDisabledAcessButton() {
    return !this.isAccess && !this.isDesigner;
  }
  @computed
  get isDisabledSubscribeButton() {
    return !this.isSubscribe && !this.isDesigner;
  }
  @computed
  get isDisabledScheduleButton() {
    return !this.isSchedule && !this.isDesigner;
  }
  @computed
  get isDisabledPresentationButton() {
    return !this.isPresentation && !this.isDesigner;
  }

  constructor(data: {}) {
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param {Object} data
   */
  @action
  populateData(data: {}) {
    data = data || {};
    this.isPresentation = data.isPresentation;
    this.isAccess = data.isAccess;
    this.isSchedule = data.isSchedule;
    this.isSubscribe = data.isSubscribe;
    this.isEdit = data.isEdit;
    this.isFullscreen = data.isFullscreen;
  }

  /**
   * Reset data
   */
  @action
  reset() {
    this.isPresentation = false;
    this.isAccess = false;
    this.isSubscribe = false;
    this.isFullscreen = false;
    this.isEdit = false;
    this.isSchedule = false;
    this.errorMessage = '';
  }

  /**
   * Enable presentation mode
   */
  @action
  togglePresentation() {
    this.isFullscreen = false;
    this.isPresentation = !this.isPresentation;
  }

  /**
   * Toggle access status
   */
  toggleAccess() {
    this.isAccess = !this.isAccess;
  }

  /**
   * Toggle schedule status
   */
  toggleSchedule() {
    this.isSchedule = !this.isSchedule;
  }

  /**
   * Toggle subscribe status
   */
  toggleSubscribe() {
    this.isSubscribe = !this.isSubscribe;
  }

  /**
   * Edit mode
   */
  setEditMode() {
    this.isEdit = true;
  }

  /**
   * Subscribe mode
   * @param {boolean} isSubscribe
   */
  switchSubscribeMode(isSubscribe: boolean) {
    this.isSubscribe = isSubscribe;
  }

  /**
   * Set Alert Details
   * @param {object} data
   */
  @action
  setAlertDetails(data: {}) {
    this.alertDetails.set(data);
  }

  /**
   * Reset Alert message
   */
  @action
  resetAlertDetails() {
    this.alertDetails.reset();
  }

  /**
   * Toggle full screen
   */
  @action
  toggleFullscreen() {
    this.isPresentation = false;
    this.isFullscreen = true;
  }

  /**
   * Exit full screen
   */
  @action
  exitFullscreen() {
    this.isPresentation = true;
    this.isFullscreen = false;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Dashboard/Izenda.DashboardDesignerMode.js